
    import { computed, defineComponent, reactive } from 'vue'
    import { useUserStore } from '@/store/user'

    import { NumericTextBox, Checkbox } from '@progress/kendo-vue-inputs'
    import { Button } from '@progress/kendo-vue-buttons'
    import { Label } from '@progress/kendo-vue-labels'
    import EquipmentTreeList from '../equipment-tree-list.vue'

    import { IBomHeaderDTO } from '@/types/bom'
    import { buildLocalization, DEBUG, EquipmentApi } from '@/util'

    interface IEquipmentTestData {
        status: string | null,
        equipmentNo: number,
        onlySpareParts: boolean,
        bomData: IBomHeaderDTO | null
    }

    export default defineComponent({
        name: 'EquipmentTest',

        components: {
            'num-textbox': NumericTextBox,
            'k-button': Button,
            checkbox: Checkbox,
            'k-label': Label,
            EquipmentTreeList
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE
            ********************************************************************************************************************/
            const userStore = useUserStore()

            /********************************************************************************************************************
             STATE
            ********************************************************************************************************************/
            const data = reactive({
                status: 'PleaseLookUpAnEquipment',
                equipmentNo: 10040957,
                onlySpareParts: false,
                bomData: null
            } as IEquipmentTestData);                

            /********************************************************************************************************************
             COMPUTED
            ********************************************************************************************************************/
            const userCurrency = computed(() => userStore.currency)
            const computedData = { userCurrency }

            /********************************************************************************************************************
             METHODS
            ********************************************************************************************************************/
            const { localize } = buildLocalization();

            async function onSubmit() {
                if (data.equipmentNo == null || userCurrency.value == null) return;
                data.status = 'Loading';

                const api = new EquipmentApi

                try {
                    if (data.onlySpareParts) {
                        DEBUG('Retrieving spare part data...');
                        data.bomData = (await api.getSparePartBom(data.equipmentNo, userCurrency.value)).data
                    }
                    else {
                        DEBUG('Retrieving BOM data...');
                        data.bomData = (await api.getExplodedEquipmentBom(data.equipmentNo, userCurrency.value)).data;
                    }

                    data.status = null;
                }
                catch {
                    data.bomData = null;
                    data.status = 'NotFound';
                }
            }

            const actions = { localize, onSubmit }

            /********************************************************************************************************************
             INTERFACE
            ********************************************************************************************************************/
            return { data, ...computedData, ...actions }
        }
    });
